import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LogoModule } from '@commons/logo/logo.component';

@Component({
  template: `
    <app-logo />
    <router-outlet />
  `,
  styleUrls: ['./password-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PasswordLayoutComponent {}

@NgModule({
  declarations: [PasswordLayoutComponent],
  imports: [RouterModule, LogoModule],
  exports: [PasswordLayoutComponent],
})
export class PasswordLayoutModule {}
